import { ElementWithProps, createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const ImageWrapper = createComponent('div', {
  className: `flex-0 flex w-full justify-center rounded-md bg-grey-1 m:h-[78px] m:max-w-[78px]`
});

export const Image = createComponent('img', {
  className: `!h-[120px] !w-[279px] self-center rounded-md bg-grey-1 object-cover m:max-h-[72px] m:max-w-[72px]`
});

export const TradeValue = createComponent('p', {
  className: 'tl-header-m'
});

export const YearMakeModelTrim = createComponent<
  ElementWithProps<{ showValue: boolean }>
>('p', ({ showValue }) => ({
  className: cx(`tl-body-m`, {
    'w-full self-center truncate': showValue
  })
}));

export const DetailsWrapper = createComponent<
  ElementWithProps<{ showValue: boolean; imgSrc: string }>
>('div', ({ imgSrc, showValue }) => ({
  className: cx(
    `flex h-full flex-col overflow-hidden`,
    showValue ? 'justify-between' : 'm:justify-center',
    { 'row-span-2 m:col-span-2': !imgSrc }
  )
}));
